import { render } from "./ScriptConfig.vue?vue&type=template&id=0d20ad8f&scoped=true"
import script from "./ScriptConfig.vue?vue&type=script&lang=js"
export * from "./ScriptConfig.vue?vue&type=script&lang=js"

import "./ScriptConfig.vue?vue&type=style&index=0&id=0d20ad8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d20ad8f"]])

export default __exports__